import type { SEOProps } from "../client/src/ssr/metadata";

export const SITE_ORIGIN = "https://www.serviway.pt";
export const SITE_NAME = "Serviway";
export const DEFAULT_SITE_IMAGE = "/manus-storage/serviway-hero-main_cee7afbe.jpg";
export const serviceRoutes = [
  { slug: "reabilitacoes-gerais", label: "Reabilitações Gerais" },
  { slug: "eletricidade", label: "Eletricidade" },
  { slug: "pichelaria", label: "Pichelaria e Canalização" },
  { slug: "carpintaria", label: "Carpintaria" },
  { slug: "serralharia", label: "Serralharia" },
  { slug: "pinturas", label: "Pinturas" },
  { slug: "limpezas", label: "Limpezas" },
  { slug: "avac-limpeza", label: "AVAC — Limpeza" },
  { slug: "jardins-piscinas", label: "Jardins e Piscinas" },
  { slug: "estores", label: "Estores" },
  { slug: "eletrodomesticos", label: "Eletrodomésticos" },
] as const;

const defaults: Record<string, Pick<SEOProps, "title" | "description">> = {
  "/": { title: "Serviway - Manutenção e Remodelação no Porto", description: "Manutenção, remodelação e reabilitação de imóveis no Grande Porto para habitações, empresas e espaços comerciais." },
  "/sobre": { title: "Sobre a Serviway | Manutenção e Remodelação no Porto", description: "Conheça a Serviway e os seus serviços de manutenção e remodelação de imóveis no Grande Porto." },
  "/contactos": { title: "Contactos | Serviway Porto", description: "Entre em contacto com a Serviway para pedidos de manutenção, remodelação e reabilitação de imóveis no Grande Porto." },
  "/planos": { title: "Planos de Manutenção Mensais e Anuais | Serviway", description: "Planos personalizados mensais e anuais de manutenção e preservação de imóveis para empresas e particulares." },
  "/recrutamento": { title: "Recrutamento e Candidaturas | Serviway Porto", description: "Envie uma candidatura espontânea à Serviway nas áreas de remodelação, reabilitação e manutenção no Grande Porto. Indique a sua função e experiência." },
  "/grupo": { title: "Grupo NOGWAY | Serviway Porto", description: "Conheça o grupo empresarial de que a Serviway faz parte." },
  "/politica-de-privacidade": { title: "Política de Privacidade | Serviway", description: "Informação sobre a proteção e o tratamento de dados pessoais no site Serviway." },
  "/termos-e-condicoes": { title: "Termos e Condições | Serviway", description: "Consulte os termos e condições aplicáveis ao site e aos serviços da Serviway." },
  "/blog": { title: "Blog de Remodelações e Reabilitações no Porto | Serviway", description: "Guias úteis para preparar a remodelação e a reabilitação de habitações, escritórios e lojas no distrito do Porto." },
  "/obrigado": { title: "Pedido Recebido | Serviway", description: "Confirmação de receção de um pedido enviado à Serviway." },
};

export type SiteRequest = {
  pathname: string;
  canonicalPath?: string;
  kind: "public" | "gated" | "missing";
  noindex: boolean;
  fallbackSEO: SEOProps;
};

export function resolveSiteRequest(url: string): SiteRequest {
  let pathname = url.split("?")[0];
  try { pathname = decodeURI(pathname); } catch { /* Match wouter's fail-safe decoding. */ }
  pathname = pathname.replace(/\/+$/, "") || "/";
  const canonicalPath = pathname === "/termos" ? "/termos-e-condicoes" : pathname;
  let kind: SiteRequest["kind"] = "missing";
  let noindex = false;
  let seo: Pick<SEOProps, "title" | "description"> = { title: "Página não encontrada | Serviway", description: "A página que procura não está disponível. Consulte os serviços da Serviway ou contacte a equipa." };
  if (pathname === "/admin" || pathname.startsWith("/admin/")) {
    kind = "gated";
    noindex = true;
    seo = { title: "Administração | Serviway", description: "Área reservada da Serviway." };
  } else if (defaults[canonicalPath]) {
    kind = "public";
    seo = defaults[canonicalPath];
    noindex = pathname === "/obrigado";
  } else {
    const service = serviceRoutes.find(item => pathname === `/servicos/${item.slug}`);
    const confirmation = serviceRoutes.find(item => pathname === `/obrigado/${item.slug}`);
    if (service) {
      kind = "public";
      seo = { title: `${service.label} no Porto | Serviway`, description: `Conheça os trabalhos de ${service.label.toLowerCase()} da Serviway e peça uma proposta adequada ao seu imóvel no Grande Porto.` };
    } else if (confirmation || pathname === "/obrigado/planos") {
      kind = "public";
      noindex = true;
      seo = { title: "Pedido Recebido | Serviway", description: "Confirmação de receção do seu pedido pela equipa Serviway." };
    } else if (/^\/blog\/[^/]+$/.test(pathname)) {
      // The article component/server blog parser checks whether the slug exists.
      // Do not import the article catalogue here: it must stay in its route chunk.
      kind = "public";
      seo = defaults["/blog"];
    }
  }
  if (kind === "missing") noindex = true;
  return {
    pathname,
    canonicalPath: noindex ? undefined : canonicalPath,
    kind,
    noindex,
    fallbackSEO: { ...seo, image: DEFAULT_SITE_IMAGE, url: SITE_ORIGIN + canonicalPath, type: "website", noindex },
  };
}
